import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect } from 'react'
import { Empty, Pagination, Table } from 'antd'
import { TableBottomPaginationBlock } from '../../../components/Common/Table'
import './style.css'
import { Link } from 'react-router-dom'

const ExportDistributeVoteTable = props => {
  const { managementAssetWarehouseStore, isLoading } = props

  const {
    assetStatisticList,
    pageIndex,
    sizeIndex,
    totalCount,
  } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  const handleChangePage = useCallback(
    p => {
      const pageIndex = p - 1
      managementAssetWarehouseStore.setFilter('pageIndex', pageIndex)
    },
    [managementAssetWarehouseStore]
  )

  const assetTypeNames = assetStatisticList?.assetTypeNames || []
  const tableColumns = [
    {
      title: <span className="custom-header">STT</span>,
      width: '30px',
      render: (id, record, index) => <span>{index + 1}</span>,
      align: 'center',
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: <span className="custom-header">Tên đơn vị</span>,
      width: '200px',
      render: record => <span>{record.departmentName}</span>,
      align: 'center',
      fixed: 'left',
      ellipsis: true,
    },
    ...assetTypeNames.map(type => ({
      title: <span className="custom-header">Số lượng</span>,
      width: '70px',
      render: record => {
        const asset = record.assetTypeList.find(asset => asset.name === type)
        return (
          <span>
            {asset && typeof asset.quantity === 'number'
              ? asset.quantity.toLocaleString('vi-VN')
              : '----'}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    })),
    {
      title: <span className="custom-header">Tổng thuế trước</span>,
      width: '110px',
      render: record => <span>{record.preTax.toLocaleString('vi-VN')}</span>,
      align: 'center',
      fixed: 'right',
      ellipsis: true,
    },
    {
      title: <span className="custom-header">Tổng thuế sau</span>,
      width: '110px',
      render: record => <span>{record.afterTax.toLocaleString('vi-VN')}</span>,
      align: 'center',
      fixed: 'right',
      ellipsis: true,
    },
  ]

  return (
    <>
      <div style={{ overflowX: 'auto' }}>
        <Table
          scroll={{ x: 'max-content' }}
          bordered
          // @ts-ignore
          dataSource={assetStatisticList?.statisticsResponses || []}
          // @ts-ignore
          columns={tableColumns}
          rowClassName={(record, index) =>
            index % 2 === 0 ? 'row-white' : 'row-blue'
          }
          pagination={false}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={'Không có dữ liệu'}
              />
            ),
          }}
          loading={isLoading}
          rowKey={record => record.departmentName}
          expandable={{
            expandedRowRender: record => (
              <div>
                <div style={{ display: 'inline-block' }}>
                  {record?.assetHistories.map(ah => (
                    <div key={ah.id}>
                      <div style={{ width: 200, display: 'inline-block' }}>
                        {ah.userName}
                      </div>
                      <div style={{ width: 100, display: 'inline-block' }}>
                        {ah.quantity}
                      </div>
                      <div style={{ width: 200, display: 'inline-block' }}>
                        {ah.assetName}
                      </div>
                      <div style={{ width: 100, display: 'inline-block' }}>
                        <Link
                          to={`/distribution-votes/other/view/${ah.proposalCode}`}
                          target="_blank"
                          rel="noopener noreferrer">
                          Tra cứu
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'inline-block' }}>
                  {record?.assetHistories.reduce(
                    (sum, item) => sum + item.quantity,
                    0
                  )}
                </div>
              </div>
            ),
          }}
        />
      </div>
      <TableBottomPaginationBlock>
        <Pagination
          current={pageIndex + 1}
          pageSize={sizeIndex}
          total={totalCount}
          showSizeChanger={false}
          onChange={handleChangePage}
        />
      </TableBottomPaginationBlock>
    </>
  )
}

export default inject('managementAssetWarehouseStore')(
  observer(ExportDistributeVoteTable)
)
